import { getAppConfig } from '@/app/config';
import { sessionTokenViaCookieOption } from '@/app/descopeClient';
import { AuthProvider as DescopeAuthProvider } from '@descope/react-sdk';

export function AuthProvider({ children }: { children: React.ReactNode }) {
  return (
    <DescopeAuthProvider
      projectId={getAppConfig().descopeProjectId}
      baseUrl={getAppConfig().authUrl}
      sessionTokenViaCookie={sessionTokenViaCookieOption}
    >
      {children}
    </DescopeAuthProvider>
  );
}
